<template>
   <div class="homepage">
      <span class="bg"></span>
      <div class="centercardcontent">
         <span class="centercard"></span>
      </div>
      <div class="card_list_content">
         <span class="card_list_content_bg"></span>
         <div class="card_list">
            <div :class="{ card_item: true, mask: item.cardSums < 1 }" v-for="item in homeInfo.idList"
                 :key="item.cardId"
                 :style="{ backgroundImage: `url(${item.cardUrl})` }">
               <div v-if="item.cardSums > 0" class="redpoint">
                  {{ item.cardSums }}
               </div>
            </div>
         </div>
      </div>
      <span class="piaodai"></span>
      <span class="title"></span>
      <div class="draw">
         <span :class="`draw_btn btn-animate-pulse ${homeInfo.time < 1 && 'mask'}`" @click="draw"></span>
         <span class="draw_text">还剩（{{ homeInfo.time }}）次抽卡机会</span>
      </div>
      <span class="lihe"></span>
      <span :class="`compose ${!homeInfo.canMixin && 'mask'}`" @click="mixin"></span>
<!--      <audio id="bgMusic" autoplay="autoplay" loop="loop" preload="auto"-->
<!--             src="https://yun.duiba.com.cn/polaris/%E8%BD%BB%E5%BF%AB3.86a7c037e6ce89eafc7bb5fd5e40cc63864eb7ee.mp3">-->
<!--      </audio>-->
<!--      <div v-if="musicStatus" class="open_musicicon" @click="event => { musicCol(false) }"></div>-->
<!--      <div v-if="!musicStatus" class="close_musicicon" @click="event => { musicCol(true) }"></div>-->

      <DrawPop v-if="isDrawPopShow" @handleClose="closeDrawPop" :cardType="drawData.cardType"
               :cardDataList="cardDataList"/>
      <GiftShow v-if="isGiftShow" @handleClose="closeGiftShow" :giftData="giftData" :platform="platform"/>
<!--      <OpenMusic :musicCol="musicCol" v-if="isOpenMusicShow" :onCancel="closeModel"/>-->

   </div>
</template>

<script>
   import {getImgById, CARD_LIST_CONFIG} from "./constant";
   import DrawPop from "../../components/DrawPop/index.vue";
   import GiftShow from "../../components/GiftShow/index.vue";
   import OpenMusic from "../../components/openMusic/index.vue"
   import Swal from 'sweetalert2'

   export default {
      name: "HomePage",
      components: {DrawPop, GiftShow, OpenMusic},
      data() {
         return {
            CARD_LIST_CONFIG: CARD_LIST_CONFIG,
            isDrawPopShow: false,
            isGiftShow: false,
            isAnima: false,
            cardDataList: [],
            cardIdList: [],
            accessToken: "",
            platform: "",
            drawData: {}, // 抽奖数据
            giftData: {}, // 合成数据
            homeInfo: {
               // 首页接口里可能包含的字端
               time: 0, // 剩余抽奖次数
               canMixin: false, // 是否可以合成
               idList: [],
            },
            musicStatus: false,
            isOpenMusicShow: false,
         };
      },
      mounted() {
         // let token = this.$route.query.token
         try {
//             this.$message({
//             message:"活动出现问题,请重新打开",
//             type:"success"
//             });

            let geturl = window.location.href;
            let getqyinfo = geturl.split("?")[1];
            let getqys = getqyinfo.split("&");
            let obj = {}; //创建空对象，接收截取的参数
            for (let i = 0; i < getqys.length; i++) {
               let item = getqys[i].split("=");
               let key = item[0];
               let value = item[1];
               obj[key] = value;
            }
            this.accessToken = obj["token"];
            this.platform = obj["platform"];
            if (
                obj["token"] == undefined ||
                obj["token"] == null ||
                obj["token"].length < 300
            ) {
               r = confirm("用户认证失败，请重新进入");
            } else {
               this.startGame();
            }
         } catch (error) {
//       this.$message({
// message:"活动出现问题,请重新打开",
// type:"success"
// });
            alert("活动出现问题,请重新打开");
         }
      },
      methods: {
         /**
          * 描述 抽卡
          * @returns {any}
          */
         getImgById: getImgById,
         startGame() {
            this.queryCardEvent();
         },
         draw() {
            if (this.homeInfo.time < 1) {
               // 无抽奖次数
               return;
            }
            if (this.isAnima) {
               alert("请稍后");
               return;
            }
            this.isAnima = true;

            // 向后端发送抽卡请求获取到id 后 设置数据打开弹窗
            this.isDrawPopShow = true;
            this.saveCardRecord();
         },
         musicCol(falg) {
            const col = document.getElementById("bgMusic");
            if (falg) {
               col.play();
               this.musicStatus = true;

            } else {
               col.pause();
               this.musicStatus = false;

            }
         },
         closeModel() {
            this.isOpenMusicShow = false;
         },

         queryMineTime() {
            let that = this;
            this.$axios
                .get("/buyer/card/card/allTimes", {
                   headers: {
                      accessToken: `${that.accessToken}`,
                   },
                })
                .then((response) => {
                   if (response.data) {
                      that.homeInfo.time = response.data.result;
                   }
                })
                .catch((err) => {
                   alert("请求失败");
                });
         },
         composeCard() {
            let that = this;
            let params = new FormData();
            params.append("eventId", that.drawData.eventId);
            params.append("ids", that.cardIdList);
            this.$axios
                .post("/buyer/card/card/composeCard", params, {
                   headers: {
                      accessToken: `${that.accessToken}`,
                      "content-type": "application/x-www-form-urlencoded",
                   },
                })
                .then((response) => {
                   if (response.data) {
                      that.startGame();
                   }
                })
                .catch((err) => {
                   alert("请求失败");
                });
         },

         saveCardRecord() {
            let that = this;
            let params = new FormData();
            params.append("eventId", that.drawData.eventId);
            params.append("cardId", that.drawData.id);
            this.$axios
                .post("/buyer/card/card/saveCardRecord", params, {
                   headers: {
                      "content-type": "application/x-www-form-urlencoded",
                      accessToken: `${that.accessToken}`,
                   },
                })
                .then((response) => {
                   if (response.data) {
                      that.allCards();
                      that.queryMineTime();
                      setTimeout(() => {
                         that.readyToCard();
                      }, 4000);
                   }
                })
                .catch((err) => {
                   alert("请求失败");
                });
         },
         queryCardEvent() {
            let that = this;
            this.$axios
                .get("/buyer/card/card/queryCardEvent", {
                   headers: {
                      accessToken: `${that.accessToken}`,
                   },
                })
                .then((response) => {
                   if (response.data) {
                      if (response.data.result != null) {
                         that.queryMineTime();
                         that.allCards();
                         that.readyToCard();
                         that.giftData = {
                            prizeImg: response.data.result.giftImage,
                         };
                      } else {
                         this.homeInfo.canMixin = false;
                         alert("没有正在开始的活动");
                      }
                   }
                })
                .catch((err) => {
                   alert("请求失败");
                });
         },
         readyToCard() {
            this.isAnima = true;
            let that = this;
            this.$axios
                .get("/buyer/card/card/readyToCard", {
                   headers: {
                      accessToken: `${that.accessToken}`,
                   },
                })
                .then((response) => {
                   if (response.data.result && response.data.result.length >= 1) {
                      that.isAnima = false;
                      that.drawData = {
                         id: response.data.result[0].id,
                         eventId: response.data.result[0].eventId,
                         cardType: response.data.result[0].cardType,
                      };
                   }
                })
                .catch((err) => {
                   alert("请求失败");
                });
         },

         allCards() {
            let idList = [];
            let that = this;
            this.$axios
                .get("/buyer/card/card/allCards", {
                   headers: {
                      accessToken: `${that.accessToken}`,
                   },
                })
                .then((response) => {
                   if (response.data) {
                      that.homeInfo.idList = response.data.result;
                      let cardType = 0;
                      response.data.result.forEach((item) => {
                         if (item.cardSums > 0) {
                            ++cardType;
                            idList.push(item.cardId);
                         }
                      });
                      that.cardDataList = response.data.result;
                      that.cardIdList = idList;
                      if (cardType >= 8) {
                         if (this.homeInfo.time > 0) {
                            this.homeInfo.canMixin = true;
                         }
                      } else {
                         that.homeInfo.canMixin = false;
                      }
                   }
                })
                .catch((err) => {
                   alert("请求失败");
                });
         },

         closeDrawPop() {
            this.isDrawPopShow = false;
         },
         /**
          * 描述 合成回调
          * @returns {any}
          */
         mixin() {
            if (!this.homeInfo.time < 0) {
               alert("集卡次数为负数，不允许兑换大礼包");
               return;
            }
            if (!this.homeInfo.canMixin) {
               // 不可以合成的判断
               return;
            }
            // this.giftData = {
            //   prizeImg:
            //     "https://yun.duiba.com.cn/aurora/assets/516436d4f58026dc926ab1482d8b8f6b84fbe666.jpg",
            // };
            this.isGiftShow = true;

            this.composeCard();
         },
         closeGiftShow() {
            this.isGiftShow = false;
         },
      },
   };
</script>

<style scoped lang="less">
   @import "../../res.less";

   .homepage {
      width: 7.5rem;
      height: 16.24rem;
      left: 0rem;
      top: 50%;
      transform: translate(0, -50%);
      position: fixed;

      .open_musicicon {
         width: 0.72rem;
         height: 0.72rem;
         position: absolute;
         top: 1.1rem;
         left: 0.28rem;
         background: url("https://yun.duiba.com.cn/polaris/music_open.afbcb0b06d66b02e985fe08ec6620e2274843838.png") no-repeat top left / 100% 100%;
      }

      .close_musicicon {
         width: 0.72rem;
         height: 0.72rem;
         position: absolute;
         top: 1.1rem;
         left: 0.28rem;
         background: url("https://yun.duiba.com.cn/polaris/music_close.78e36df75a1600ed7f5332f0f33993a5c7844922.png") no-repeat top left / 100% 100%;
      }

      .bg {
         width: 7.5rem;
         height: 16.24rem;
         left: 0rem;
         top: 0rem;
         position: absolute;
         .sparkBg("HomePage/bg.png");
      }

      .centercardcontent {
         width: 2.35rem;
         height: 3.35rem;
         left: 2.62rem;
         top: 4.85rem;
         position: absolute;
         transform-style: preserve-3d;
         perspective: 10rem;
      }

      .centercard {
         width: 100%;
         height: 100%;
         left: 0;
         position: absolute;
         .sparkBg("HomePage/CenterCard.png");
         animation: card_move 4s 0s infinite;
      }

      .card_list_content {
         width: 7.32rem;
         height: 4.12rem;
         left: 0.08rem;
         top: 10.13rem;
         position: absolute;

         .card_list_content_bg {
            width: 7.32rem;
            height: 4.12rem;
            left: 0rem;
            top: 0rem;
            position: absolute;
            .sparkBg("HomePage/card_list_content_bg.png");
         }

         .card_list {
            width: 3.83rem;
            height: 2.56rem;
            left: 2.74rem;
            top: 0.67rem;
            position: absolute;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .card_item {
               width: 0.8rem;
               height: 1.15rem;
               flex: 0 0 auto;
               position: relative;
               .bgwithoutUrl;

               .redpoint {
                  width: 0.35rem;
                  line-height: 0.35rem;
                  height: 0.35rem;
                  right: -0.16rem;
                  top: -0.13rem;
                  position: absolute;
                  font-size: 0.28rem;
                  background-color: rgb(235, 19, 19);
                  color: white;
                  border-radius: 50%;
               }
            }
         }
      }

      .piaodai {
         width: 7.5rem;
         height: 5.57rem;
         left: 0rem;
         top: 8.63rem;
         position: absolute;
         .sparkBg("HomePage/piaodai.png");
      }

      .compose {
         width: 2.14rem;
         height: 0.95rem;
         left: 0.68rem;
         top: 12.5rem;
         position: absolute;
         .sparkBg("HomePage/compose.png");
      }

      .title {
         width: 3.68rem;
         height: 1.7rem;
         left: 2.01rem;
         top: 2.85rem;
         position: absolute;
         .sparkBg("HomePage/title.png");
      }

      .draw {
         width: 2.01rem;
         height: 0.97rem;
         left: 2.63rem;
         top: 8.3rem;
         position: absolute;

         .draw_btn {
            width: 2.21rem;
            height: 0.91rem;
            left: 0rem;
            top: 0rem;
            position: absolute;
            .sparkBg("HomePage/draw_btn.png");
         }

         .draw_text {
            width: 5.00rem;
            height: 0.14rem;
            left: -1.4rem;
            top: 1.13rem;
            position: absolute;
            font-size: 0.29rem;
            line-height: 0.14rem;
            color: rgba(84, 46, 40, 1);
         }
      }

      .lihe {
         width: 2.23rem;
         height: 3.02rem;
         left: 0.56rem;
         top: 10.23rem;
         position: absolute;
         .sparkBg("HomePage/lihe.png");
      }

      @keyframes card_move {
         0% {
            transform: rotateY(0deg);
         }

         13% {
            transform: rotateY(-20deg);
         }

         26% {
            transform: rotateY(0deg);
         }

         100% {
            transform: rotateY(0deg);
         }
      }
   }
</style>



// WEBPACK FOOTER //
// src/page/Homepage/index.vue